import { Component, OnInit, Renderer2 } from '@angular/core';
import { environment } from "../../environments/environment";
import { StoreHelper } from '../shared/helpers/store.helper';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { HttpService } from '../shared/services/http.service';


@Component({
    selector: 'app-sso',
    templateUrl: './sso.component.html',
    styleUrls: ['./sso.component.scss'],
    standalone: false
})
export class SsoComponent implements OnInit {

  haveAuthToken = false
  qpObserver = null
  loading = false
  url = ''

  constructor(private router: Router, private authService: AuthService, private route: ActivatedRoute,
    private renderer: Renderer2,
    private httpService: HttpService
  ) { }

  ngOnInit() {

    // get the token query param
    this.url = environment.apiUrl + "/ub2/auth/login?activationCode=" + StoreHelper.getObject('activationCode')

    this.qpObserver = this.route.queryParams.subscribe( async (params: Params) => {

      const exchange = params['exchange']

      if( !exchange ){
        return
      }

      this.haveAuthToken = true
          
      
      const exchangeResponse: any = await this.httpService.postAsync(
        "user/exchange",
        { exchange }
      );


      if( exchangeResponse.success ){
        const token = exchangeResponse['token']
        const hr = exchangeResponse['hr'] == 1 ? true : false
        const superish = exchangeResponse['super'] == 1 ? true : false
        const client_id = exchangeResponse['client_id']
        const client_name = exchangeResponse['client_name']
        const kind = exchangeResponse['kind']

        const userObject = {
          token,
          hr,
          super : superish,
          client_id,
          client_name,
          kind
        }

        if( token ){
          this.authService.ssoSignin( userObject )
          this.router.navigate(['/start'])
        }
      }else{
        this.router.navigate(['/login'])
      }
    })
  }

  // unsubscribe the queryparams listener in component destroy

  ngOnDestroy(): void {
    this.qpObserver.unsubscribe()
  }

}
